var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"app-header"}},[_c('navbar',{attrs:{"customStyles":_vm.customStyles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }